import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";

import Button from "@khanacademy/wonder-blocks-button";
import {View} from "@khanacademy/wonder-blocks-core";
import {spacing} from "@khanacademy/wonder-blocks-tokens";

import {NUM_RESULTS_PER_PAGE} from "./use-curated-indexed-content-search.ts";

type Props = {
    pageNumber: number;
    numberOfResultsInPage: number;
    setPageNumber: (pageNumber: number, direction: "previous" | "next") => void;
};

const Pagination = (props: Props) => {
    const {pageNumber, numberOfResultsInPage, setPageNumber} = props;

    return (
        <View style={styles.paginationContainer}>
            <View style={styles.pagination}>
                {pageNumber > 1 && (
                    <Button
                        kind="secondary"
                        onClick={() => {
                            setPageNumber(pageNumber - 1, "previous");
                        }}
                        size="small"
                        style={styles.paginationBtn}
                    >
                        {t`Previous`}
                    </Button>
                )}
                <div>{t`Page ${pageNumber}`}</div>
                {numberOfResultsInPage === NUM_RESULTS_PER_PAGE && (
                    <Button
                        id="next-page-button"
                        kind="secondary"
                        onClick={() => {
                            setPageNumber(pageNumber + 1, "next");
                        }}
                        size="small"
                        style={styles.paginationBtn}
                    >
                        {t`Next`}
                    </Button>
                )}
            </View>
        </View>
    );
};

const styles = StyleSheet.create({
    paginationContainer: {
        alignItems: "end",
        paddingBottom: spacing.xSmall_8,
        paddingTop: spacing.xSmall_8,
    },
    pagination: {
        flexDirection: "row",
        gap: spacing.medium_16,
        alignItems: "baseline",
    },
    paginationBtn: {
        width: "fit-content",
        paddingLeft: spacing.medium_16,
    },
});

export default Pagination;
